<template>
    <div class="px-4">
        <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver </v-btn>

        <h4 class="text-center">Nominaciones</h4>
        <div class="text-right">
            <v-checkbox v-model="eliminados" :label="`${eliminados?'incluir eliminados':'viendo solo activos'}`"></v-checkbox>
            <v-btn tile outlined color="green" @click="openregistrar()"> <v-icon left>mdi-plus</v-icon> Registrar </v-btn>
        </div>
        <v-data-table :loading="loading" :headers="headers" :items="desserts" disable-pagination hide-default-footer :items-per-page="5" class="elevation-1">
            <template v-slot:[`item.deleted_at`]="{ item }">
                <p class="red--text"> {{ item.deleted_at }} </p>
            </template>
            <template v-slot:[`item.deleted_by`]="{ item }">
                <p class="red--text"> {{ item.deleted_by }} </p>
            </template>
            <template v-slot:[`item.opt`]="{ item }">
                <div style="min-width: 120px;">
                    <!-- <v-btn tile small text color="orange" @click="openregistrar(item)"> <v-icon>mdi-pencil</v-icon> </v-btn> -->
                    <v-btn tile small text color="red" @click="confirmacionDelete(item)"> <v-icon>mdi-delete</v-icon> </v-btn>
                </div>
            </template>
        </v-data-table>

        <registrar ref="refagregar" v-on:success="cargarDatos"/>
    </div>
  </template>

<script>
import registrar from './registrar.vue';
import xaxios from '@/xaxios';

export default {
    components:{registrar},
    data () {
        return {
            headers: [ 
                { text: 'ID', value: 'id' },
                { text: 'Valor', value: 'valor' },
                { text: 'creado por', value: 'created_by' },
                // { text: 'creado', value: 'created_at' },
                // { text: 'actualizado', value: 'updated_at' },
                // { text: 'eliminado', value: 'deleted_at' },
                // { text: 'actualizado por', value: 'updated_by' },
                // { text: 'eliminado por', value: 'deleted_by' },
                { text: '', value: 'opt' },
            ],
            desserts: [],
            eliminados: false,
            loading: false,
        }
    },
    watch:{
        eliminados: function(){
            this.cargarDatos();
        }
    },
    methods:{
        openregistrar(item=null){
            this.$refs.refagregar.openmodal(item);
        },
        async cargarDatos(){
            this.loading = true;
            this.desserts = [];
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/denominaciones`;
            if(this.eliminados) url += '?eliminados=true';
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            if(res && res.data ) this.desserts = res.data.data; 
            this.loading = false;
        },
        confirmacionDelete(item) {
        const vue = this;
        var opt = {
          verification: 'eliminar',
          verificationHelp: 'Escriba "[+:verification]" para eliminar esta nominacion.',
          okText: 'eliminar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'hard',
        };
        var message = {
          title: 'Confirmar',
          body:
            '<br> <b>NOTA:</b> Una ves realizada la accion no hay vuelta atras </br></br>',
        };
        this.$dialog
          .confirm(message, opt)
          .then(async function(dialog) { 
            const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/denominaciones/${item.id}`;
            const res = await xaxios.delete(url).then(x=>x).catch(x=>x);
            window.console.log(res);
            dialog.close();
            vue.cargarDatos();
          })
          .catch(function() {});
      },
    },
    async mounted(){ 
        this.cargarDatos();
        
    }
}
</script>